import React from 'react';

const BrandArea = () => {
  const brands = [
    { logo: "/assets/img/company-logo/morningstar.png", alt: "Morningstar" },
    { logo: "/assets/img/company-logo/image (3).png", alt: "Company 3" },
    { logo: "/assets/img/company-logo/image (4).png", alt: "Company 4" },
    { logo: "/assets/img/company-logo/image (5).png", alt: "Company 5" },
    { logo: "/assets/img/company-logo/image (7).png", alt: "Company 7" },
    { logo: "/assets/img/company-logo/image (8).png", alt: "Company 8" },
    { logo: "/assets/img/company-logo/image (9).png", alt: "Company 9" },
    { logo: "/assets/img/company-logo/image (10).png", alt: "Company 10" },
    { logo: "/assets/img/company-logo/image (11).png", alt: "Company 11" },
    { logo: "/assets/img/company-logo/globent.webp", alt: "Globent" },
  ];

  return (
    <div className="br-brand-area mr-t-b-60">
      <div className="container-fluid">
        <div className="br-marquee-container">
          <div className="br-marquee-content">
            {brands.map((brand, index) => (
              <div className="br-brand__item" key={`first-${index}`}>
                <a href="#">
                  <img
                    src={brand.logo}
                    alt={brand.alt}
                    style={{ height: 25 }}
                    onError={(e) => {
                      e.target.src = '/assets/img/default-logo.png';
                    }}
                  />
                </a>
                <img 
                  src="/assets/img/icons/brand_star.svg" 
                  alt="star" 
                  onError={(e) => {
                    e.target.style.display = 'none';
                  }}
                />
              </div>
            ))}
            
            {brands.map((brand, index) => (
              <div className="br-brand__item" key={`second-${index}`}>
                <a href="#">
                  <img
                    src={brand.logo}
                    alt={brand.alt}
                    style={{ height: 25 }}
                  />
                </a>
                <img src="/assets/img/icons/brand_star.svg" alt="star" />
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default BrandArea;